import path from "path"

// defines route path and pathname declaration
export const routePaths = {
  home: {
    path: "/home",
    pathName: "home"
  },
  manage: {
    externalConnection: {
      path: "external-connection-manager",
      pathName: "external-connection-manager"
    },
    requestConnection: {
      path: "request-external-connection",
      pathName: "request-external-connection"
    }
  },
  provider: {
    configure: {
      path: "",
      pathName: "configure"
    },
    success: {
      path: "success",
      pathName: "create-success"
    },
    uploadHistory: {
      path: "upload-history",
      pathName: "upload-history"
    },
    digitalTwin: {
      path: "digital-twin-provider",
      pathName: "digital-twin-provider"
    },
    assets: {
      path: "assets",
      pathName: "assets-overview"
    },
    simulateOffers: {
      path: "simulate-offers",
      pathName: "simulate-offers"
    },
    messagesBrowser: {
      path: "messages-browser-provider",
      pathName: "messages-browser-provider"
    },
    certificates: {
      path: "provided-certificates",
      pathName: "provided-certificates"
    }
  },
  consume: {
    offers: {
      path: "offers",
      pathName: "offers"
    },
    downloadHistory: {
      path: "download-history",
      pathName: "download-history"
    },
    digitalTwin: {
      path: "digital-twin-consume",
      pathName: "digital-twin-consume"
    },
    messagesBrowser: {
      path: "messages-browser-consume",
      pathName: "messages-browser-consume"
    },
    certificates: {
      path: "consumed-certificates",
      pathName: "consumed-certificates"
    }
  },
  prepare: {
    models: {
      path: "models",
      pathName: "models"
    },
    mapping: {
      path: "mapping",
      pathName: "mapping"
    },
    converter: {
      path: "converter",
      pathName: "converter"
    }
  },
  govern: {
    policy: {
      path: "policies",
      pathName: "policies"
    },
    publicationTemplates: {
      path: "publication-templates",
      pathName: "publication-templates"
    },
    contractAgreements: {
      path: "contract-agreements",
      pathName: "contract-agreements"
    },
    connectors: {
      path: "connectors",
      pathName: "connectors"
    },
    contractDefinitions: {
      path: "contract-definitions",
      pathName: "contract-definitions"
    }
  },
  applications: {
    electronicControlUnit: {
      path: "electronic-control-unit",
      pathName: "electronic-control-unit",
      children: {
        sentMessages: { path: "sent-messages", pathName: "electronic-control-unit.sent-messages" },
        receivedMessages: {
          path: "received-messages",
          pathName: "electronic-control-unit.received-messages"
        },
        assets: { path: "assets", pathName: "electronic-control-unit.assets" },
        processLogs: { path: "process-logs", pathName: "electronic-control-unit.process-logs" },
        connectors: { path: "connectors", pathName: "electronic-control-unit.connectors" },
        policies: { path: "policies", pathName: "electronic-control-unit.policies" }
      }
    },
    certificateManagement: {
      path: "certificate-management",
      pathName: "certificate-management",
      children: {
        publish: { path: "publish-certificate", pathName: "certificate-management.publish" },
        myCertificates: {
          path: "my-certificates",
          pathName: "certificate-management.my-certificates"
        },
        discover: { path: "discover-certificates", pathName: "certificate-management.discover" },
        consumptionHistory: {
          path: "consumption-history",
          pathName: "certificate-management.consumption-history"
        },
        inboundRequests: {
          path: "inbound-requests",
          pathName: "certificate-management.inbound-requests"
        },
        outboundStatus: {
          path: "outbound-status",
          pathName: "certificate-management.outbound-status"
        }
      }
    },
    pcfExchange: {
      path: "pcf-exchange",
      pathName: "pcf-exchange",
      children: {
        createOffer: { path: "create-offer", pathName: "pcf-exchange.create-offer" },
        discover: { path: "discover", pathName: "pcf-exchange.discover" },
        requests: { path: "data-requests", pathName: "pcf-exchange.requests" },
        history: { path: "exchange-history", pathName: "pcf-exchange.history" }
      }
    },
    pcfExchangeV9: {
      path: "pcf-exchange-v9",
      pathName: "pcf-exchange-v9",
      children: {
        createOffer: { path: "create-offer", pathName: "pcf-exchange-v9.create-offer" },
        discover: { path: "discover", pathName: "pcf-exchange-v9.discover" },
        requests: { path: "data-requests", pathName: "pcf-exchange-v9.requests" },
        history: { path: "exchange-history", pathName: "pcf-exchange-v9.history" },
        aspects: { path: "aspects", pathName: "pcf-exchange-v9.aspects" },
        assets: { path: "assets", pathName: "pcf-exchange-v9.assets" }
      }
    },
    cyberSecurityKPIs: {
      path: "cyber-security-kpis",
      pathName: "cyber-security-kpis",
      children: {
        create: { path: "create-metrics", pathName: "cyber-security-kpis.create" }
      }
    },
    pcfRequests: {
      path: "pcf-requests",
      pathName: "pcf-requests"
    },
    pcfExchangeHistory: {
      path: "pcf-exchange-history",
      pathName: "pcf-exchange-history"
    },
    blockNotifications: {
      path: "block-notifications",
      pathName: "block-notifications",
      children: {
        send: { path: "send", pathName: "block-notifications.send" },
        sentHistory: { path: "sent-history", pathName: "block-notifications.sent-history" },
        receivedHistory: {
          path: "received-history",
          pathName: "block-notifications.received-history"
        }
      }
    },
    traceability: {
      path: "traceability",
      pathName: "traceability",
      children: {
        createOffer: { path: "create-offer", pathName: "traceability.create-offer" },
        discover: { path: "discover", pathName: "traceability.discover" },
        notifications: { path: "notifications", pathName: "traceability.notifications" },
        industryCoreNotifications: {
          path: "industry-core-notifications",
          pathName: "traceability.industry-core-notifications"
        },
        contractAgreements: {
          path: "contract-agreements",
          pathName: "traceability.contract-agreements"
        },
        exchangeHistory: { path: "exchange-history", pathName: "traceability.exchange-history" }
      }
    }
  },
  jobs: {
    path: "/jobs",
    pathName: "jobs"
  }
}
